import GoogleMapsClient from './GoogleMapsClient.js';

export default {
  GoogleMapsClient: GoogleMapsClient
};
//# sourceMappingURL=index.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/es/src/clients/index.js